

(function faqProduit () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "faq-produit";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

    const {auth, getUrlsProduct, getUrlsProductContents, isTracking, sendTrackingEvents, getAppCetelem} = GlobalSite.checkDependency('GlobalSite.inbentaApi');

    $(() => {
      $(async () => {
        const [inbentaAuth, urlsProduct, cetelemCustomVar] = await Promise.all([
            auth(),
            getUrlsProduct(),
            getAppCetelem()
        ]).catch(reason => {
            Log.log(reason)
            return;
        })

        const currentPath = window.location.pathname;
        const productContents = urlsProduct && urlsProduct?.results[0]?.value?.urls[find((url) => url.url === currentPath) || [0]]?.contents.replaceAll(';', ',');
        const urlsProductContents = inbentaAuth && (await getUrlsProductContents(productContents, 'faq-product'));

        const faqList = document.querySelector('#faq-produit-list');
        const errorBanner = faqList.querySelector('.faq__list-item--banner-message');
        const skeletonItems = faqList.querySelectorAll('.faq__list-item--loader');

        if (skeletonItems && skeletonItems.length > 0) {
            skeletonItems.forEach(item => item.remove());
        }

        if (faqList && urlsProductContents?.results.length > 0) {
            const answers = urlsProductContents;

            answers.results.map(({tracking: {clickCode}, title, attributes: {ANSWER_TEXT}}) => {
                const htmlAnswer = `
                    <li class="faq__list-item">
                        <details
                            data-tracking-type="click"
                            data-source="faq-product-track"
                            data-tracking-value="${clickCode}"
                            class="accordion"
                        >
                            <summary class="accordion__title" aria-label="${title}">
                                <h3>${title}</h3>
                                <span class="accordion__title--icon i-chevron-down" />
                            </summary>
                            <div class="accordion__text">
                                ${ANSWER_TEXT}
                            </div>
                        </details>
                    </li>
                `

                faqList.insertAdjacentHTML('afterbegin', htmlAnswer);
            })

            const faqAccordionList = document.querySelectorAll('#faq-produit-list .faq__list-item .accordion');
            const inbentaTracking = await isTracking();

            if (faqAccordionList && faqAccordionList.length > 0 && inbentaTracking) {
                faqAccordionList.forEach((accordion) => {
                    accordion.addEventListener('click', () => {
                        if (!accordion.hasAttribute('open')) {
                            const source = accordion.dataset.source;
                            const trackingType = accordion.dataset.trackingType;
                            const trackingValue = accordion.dataset.trackingValue;

                            sendTrackingEvents({ type: trackingType, data: { code: trackingValue }}, source);
                            Log.log({ trackingType, trackingValue, source });
                        }
                    });
                })
            }
        } else {
            errorBanner.classList.toggle('hide');
        }
      });
    })
})()